import { useState, useEffect } from 'react';
import { Eye, Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { API_URL } from '@/config/api';

export const CanteenVisibilityCard = () => {
  const { token } = useAuth();
  const [canteenVisible, setCanteenVisible] = useState(true);
  const [toggling, setToggling] = useState(false);

  useEffect(() => {
    const fetchVisibility = async () => {
      try {
        const r = await fetch(`${API_URL}/api/admin/menu/canteen-visibility`, {
          headers: { 'Authorization': `Bearer ${token}` }, credentials: 'include'
        });
        if (r.ok) {
          const d = await r.json();
          setCanteenVisible(d.canteen_visible);
        }
      } catch {}
    };
    fetchVisibility();
  }, [token]);

  const toggle = async () => {
    setToggling(true);
    try {
      const r = await fetch(`${API_URL}/api/admin/menu/canteen-visibility`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ canteen_visible: !canteenVisible })
      });
      if (!r.ok) { const d = await r.json(); throw new Error(d.detail || 'Failed'); }
      const d = await r.json();
      setCanteenVisible(d.canteen_visible);
      toast.success(d.message);
    } catch (e) { toast.error(e.message); }
    finally { setToggling(false); }
  };

  return (
    <Card className="mb-6">
      <CardContent className="p-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${canteenVisible ? 'bg-blue-100' : 'bg-gray-100'}`}>
            <Eye className={`h-5 w-5 ${canteenVisible ? 'text-blue-600' : 'text-gray-400'}`} />
          </div>
          <div>
            <p className="font-medium text-sm text-secondary-900">Canteen on Customer Menu</p>
            <p className="text-xs text-muted-foreground">
              {canteenVisible ? 'Customers can see and order canteen items (drinks, snacks)' : 'Canteen is hidden from customers — items remain in BOH'}
            </p>
          </div>
        </div>
        <button
          onClick={toggle}
          disabled={toggling}
          className={`w-12 h-7 rounded-full p-1 transition-colors ${canteenVisible ? 'bg-blue-500' : 'bg-gray-300'}`}
          data-testid="canteen-toggle"
        >
          {toggling ? (
            <div className="w-5 h-5 flex items-center justify-center"><Loader2 className="h-4 w-4 animate-spin text-white" /></div>
          ) : (
            <div className={`w-5 h-5 bg-white rounded-full shadow transition-transform ${canteenVisible ? 'translate-x-5' : 'translate-x-0'}`} />
          )}
        </button>
      </CardContent>
    </Card>
  );
};

export default CanteenVisibilityCard;
